module.exports = __webpack_public_path__ + "static/media/56.d74841b7.jpg";